<template>
  <div class="mobile-container innovation-awards-mobile">
    <!-- <page-header>{{ 'CSGCT 创新之星' | dealLanguage('CSGCT Innovation Awards') }}</page-header> -->
    <div class="awards-wrapper">
      <section class="hero-section">
        <div class="hero-content">
          <div class="hero-eyebrow">{{ pick(content.hero.eyebrow) }}</div>
          <h1 class="hero-title">{{ pick(content.hero.title) }}</h1>
          <p class="hero-desc">{{ pick(content.hero.desc) }}</p>
        </div>
        <div class="hero-visual" aria-hidden="true">
          <div class="trophy">
            <div class="cup-top"></div>
            <div class="cup-body"></div>
            <div class="cup-handle handle-left"></div>
            <div class="cup-handle handle-right"></div>
            <div class="cup-base"></div>
            <div class="cup-stand"></div>
            <div class="trophy-star">★</div>
          </div>
        </div>
        <div class="hero-actions">
          <button class="action-btn primary" @click="scrollToSection('materials')">
            {{ pick(content.hero.buttons.apply) }}
          </button>
          <button class="action-btn ghost" @click="scrollToSection('eligibility')">
            {{ pick(content.hero.buttons.condition) }}
          </button>
          <button class="action-btn ghost" @click="goContact">
            {{ pick(content.hero.buttons.contact) }}
          </button>
        </div>
      </section>

      <section class="section-card about-section">
        <div class="section-header">
          <span class="section-tag">01</span>
          <h2>{{ pick(content.about.title) }}</h2>
        </div>
        <div class="about-text">
          <p v-for="(item, index) in content.about.paragraphs" :key="'about-' + index">
            {{ pick(item) }}
          </p>
        </div>
      </section>

      <section ref="eligibility" class="section-card">
        <div class="section-header">
          <span class="section-tag">02</span>
          <h2>{{ pick(content.eligibility.title) }}</h2>
        </div>
        <div class="eligibility-grid">
          <div
            v-for="(item, index) in content.eligibility.items"
            :key="'eligibility-' + index"
            class="eligibility-card"
          >
            <div :class="['icon-box', item.icon]"></div>
            <h3>{{ pick(item.title) }}</h3>
            <p>{{ pick(item.desc) }}</p>
          </div>
        </div>
      </section>

      <section class="section-card">
        <div class="section-header">
          <span class="section-tag">03</span>
          <h2>{{ pick(content.applyTypes.title) }}</h2>
        </div>
        <div class="apply-type-list">
          <div
            v-for="(item, index) in content.applyTypes.items"
            :key="'apply-type-' + index"
            class="apply-type-card"
          >
            <h3>{{ pick(item.title) }}</h3>
            <p v-for="(desc, descIndex) in item.desc" :key="'apply-desc-' + index + '-' + descIndex">
              {{ pick(desc) }}
            </p>
          </div>
        </div>
      </section>

      <section ref="materials" class="section-card">
        <div class="section-header">
          <span class="section-tag">04</span>
          <h2>{{ pick(content.materials.title) }}</h2>
        </div>
        <p class="section-intro">{{ pick(content.materials.intro) }}</p>
        <div class="form-card">
          <Form ref="current-form" :model="currentForm" :rules="ruleValidate" label-position="top">
            <FormItem prop="fullName" :label="'公司全称' | dealLanguage('Company Full Name')">
              <Input
                v-model="currentForm.fullName"
                type="text"
                :placeholder="'请填写公司全称' | dealLanguage('Please fill in the company full name')"
              ></Input>
            </FormItem>
            <FormItem prop="shortName" :label="'公司简称' | dealLanguage('Company Short Name')">
              <Input
                v-model="currentForm.shortName"
                type="text"
                :placeholder="'请填写公司简称' | dealLanguage('Please fill in the company short name')"
              ></Input>
            </FormItem>
            <FormItem prop="name" :label="'联系人姓名' | dealLanguage('Contact Name')">
              <Input
                v-model="currentForm.name"
                type="text"
                :placeholder="'请填写联系人姓名' | dealLanguage('Please fill in the contact name')"
              ></Input>
            </FormItem>
            <FormItem prop="title" :label="'联系人职务' | dealLanguage('Contact Title')">
              <Input
                v-model="currentForm.title"
                type="text"
                :placeholder="'请填写联系人职务' | dealLanguage('Please fill in the contact title')"
              ></Input>
            </FormItem>
            <FormItem prop="mobile" :label="'联系人手机' | dealLanguage('Mobile Number')">
              <Input
                v-model="currentForm.mobile"
                type="text"
                :placeholder="'请输入联系人手机' | dealLanguage('Please enter the contact mobile number')"
                autocomplete="off"
              ></Input>
            </FormItem>
            <FormItem prop="email" label="Email">
              <Input
                v-model="currentForm.email"
                type="text"
                :placeholder="'请填写邮箱' | dealLanguage('Please fill in your email')"
              ></Input>
            </FormItem>
            <FormItem prop="compDesc" :label="'公司简介' | dealLanguage('Company Introduction')">
              <Input
                v-model="currentForm.compDesc"
                type="textarea"
                :rows="4"
                :placeholder="'请填写公司简介，介绍核心管线或技术平台' | dealLanguage('Please fill in the company introduction, including core pipeline or platform')"
              ></Input>
            </FormItem>
            <FormItem prop="content" :label="'创新说明' | dealLanguage('Innovation Statement')">
              <Input
                v-model="currentForm.content"
                type="textarea"
                :rows="6"
                :placeholder="'请填写创新说明，500字以内' | dealLanguage('Please fill in the innovation statement within 500 words')"
              ></Input>
              <div class="field-tip">
                <span>{{ pick(content.materials.exampleTitle) }}</span>
                <span :class="['word-count', innovationWordCount > 500 && 'danger']">
                  {{ innovationWordCount }}/500
                </span>
              </div>
            </FormItem>
            <FormItem prop="milestone" :label="'最新里程碑' | dealLanguage('Latest Milestones')">
              <Input
                v-model="currentForm.milestone"
                type="textarea"
                :rows="4"
                :placeholder="'请填写最新的临床、注册、融资、BD或合作进展' | dealLanguage('Please fill in the latest clinical, regulatory, financing, BD or partnership updates')"
              ></Input>
            </FormItem>
            <FormItem prop="logoPath" :label="'公司 Logo' | dealLanguage('Company Logo')">
              <div class="upload-wrapper">
                <input
                  ref="logoInput"
                  class="file-input"
                  type="file"
                  accept=".png,.jpg,.jpeg,.webp"
                  @change="handleLogoChange"
                />
                <Button @click="triggerLogoSelect">
                  {{ '上传 Logo' | dealLanguage('Upload Logo') }}
                </Button>
                <span class="upload-text">
                  {{ '支持 PNG、JPG、JPEG、WEBP' | dealLanguage('Supports PNG, JPG, JPEG and WEBP') }}
                </span>
              </div>
              <div class="upload-file" v-if="logoDisplayName">
                <span>{{ logoDisplayName }}</span>
                <Button type="text" @click="handleRemoveLogo">
                  {{ '删除' | dealLanguage('Remove') }}
                </Button>
              </div>
            </FormItem>
            <FormItem :label="'附件（可选）' | dealLanguage('Attachment (Optional)')">
              <div class="upload-wrapper">
                <input
                  ref="attachmentInput"
                  class="file-input"
                  type="file"
                  accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.ppt,.pptx,.zip"
                  @change="handleAttachmentChange"
                />
                <Button @click="triggerAttachmentSelect">
                  {{ '上传附件' | dealLanguage('Upload Attachment') }}
                </Button>
                <span class="upload-text">
                  {{
                    '支持 PNG、JPG、JPEG、PDF、DOC、DOCX、PPT、PPTX、ZIP'
                      | dealLanguage('Supports PNG, JPG, JPEG, PDF, DOC, DOCX, PPT, PPTX and ZIP')
                  }}
                </span>
              </div>
              <div class="upload-file" v-if="attachmentDisplayName">
                <span>{{ attachmentDisplayName }}</span>
                <Button type="text" @click="handleRemoveAttachment">
                  {{ '删除' | dealLanguage('Remove') }}
                </Button>
              </div>
            </FormItem>
            <div class="submit-btn-wrapper">
              <Button type="primary" class="submit-btn" :loading="buttonLoading" @click="handleSubmit">
                <span v-if="buttonLoading">{{ '提交中' | dealLanguage('Submitting') }}</span>
                <span v-else>{{ '提交申报' | dealLanguage('Submit Application') }}</span>
              </Button>
            </div>
          </Form>
        </div>
        <div class="example-card">
          <div class="example-title">{{ pick(content.materials.exampleTitle) }}</div>
          <p>{{ pick(content.materials.example) }}</p>
        </div>
      </section>

      <section class="section-card">
        <div class="section-header">
          <span class="section-tag">05</span>
          <h2>{{ pick(content.benefits.title) }}</h2>
        </div>
        <div class="benefit-list">
          <div v-for="(item, index) in content.benefits.items" :key="'benefit-' + index" class="benefit-card">
            <h3>{{ pick(item.title) }}</h3>
            <ul>
              <li v-for="(line, lineIndex) in item.list" :key="'benefit-line-' + index + '-' + lineIndex">
                {{ pick(line) }}
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section class="section-card">
        <div class="section-header">
          <span class="section-tag">06</span>
          <h2>{{ pick(content.timeline.title) }}</h2>
        </div>
        <div class="timeline-scroll">
          <div class="timeline">
            <div class="timeline-line"></div>
            <div
              v-for="(item, index) in content.timeline.stages"
              :key="'timeline-' + index"
              class="timeline-item"
            >
              <div class="timeline-dot"></div>
              <div class="timeline-short">{{ pick(item.short) }}</div>
              <div class="timeline-card">
                <div class="timeline-time">{{ pick(item.time) }}</div>
                <div class="timeline-title">{{ pick(item.title) }}</div>
                <p>{{ pick(item.desc) }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import content from './content'
import formMixin from './formMixin'
import { mapState } from 'vuex'
import filter from 'js/filter'

export default {
  mixins: [formMixin],
  metaInfo() {
    return {
      title: filter.dealLanguage('CSGCT 创新之星', 'CSGCT Innovation Awards'),
    }
  },
  inject: ['wxShare'],
  components: {
    PageHeader,
  },
  data() {
    return {
      content,
    }
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      vbef_path: (state) => state.vbef_path,
    }),
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('CSGCT 创新之星-CSGCT', 'CSGCT Innovation Awards-CSGCT'),
      linkurl: this.vbef_path + '/innovationAwards',
    })
  },
  methods: {
    pick(item) {
      if (!item || typeof item !== 'object') return item || ''
      return this.language === 'en' ? item.en : item.zh
    },
    scrollToSection(refName) {
      const target = this.$refs[refName]
      if (target) {
        const top = target.getBoundingClientRect().top + window.pageYOffset - 64
        window.scrollTo({
          top: Math.max(top, 0),
          behavior: 'smooth',
        })
      }
    },
    goContact() {
      this.$router.push({
        name: 'contactUs',
        query: {
          language: this.language,
        },
      })
    },
  },
}
</script>

<style lang='stylus' scoped>
.innovation-awards-mobile
  min-height 100vh

.awards-wrapper
  padding 0.3rem 0.4rem 0.6rem

.hero-section
  background linear-gradient(135deg, #3A0408 0%, #8F0E17 48%, #C8161D 100%)
  border-radius 0.32rem
  padding 0.42rem 0.32rem
  color #FFFFFF
  box-shadow 0 0.18rem 0.4rem rgba(200, 22, 29, 0.2)

.hero-eyebrow
  display inline-flex
  align-items center
  padding 0.08rem 0.18rem
  border 1px solid rgba(255, 255, 255, 0.2)
  border-radius 999px
  background rgba(255, 255, 255, 0.08)
  font-weight bold
  line-height 0.32rem
  letter-spacing 0.1rem

.hero-title
  margin-top 0.2rem
  font-size 0.52rem
  line-height 0.72rem
  font-weight 700

.hero-desc
  margin-top 0.16rem
  font-size 0.28rem
  line-height 0.46rem
  color rgba(255, 255, 255, 0.86)

.hero-visual
  display flex
  justify-content center
  margin-top 0.34rem

.trophy
  position relative
  width 2.2rem
  height 2.7rem

.cup-top
  position absolute
  top 0.12rem
  left 0.42rem
  width 1.36rem
  height 0.34rem
  border-radius 999px
  background linear-gradient(180deg, #FFF7D8 0%, #F9D66D 100%)

.cup-body
  position absolute
  top 0.32rem
  left 0.56rem
  width 1.08rem
  height 1.26rem
  background linear-gradient(180deg, #FFF6D1 0%, #F2BE3E 54%, #C88A12 100%)
  clip-path polygon(14% 0%, 86% 0%, 100% 100%, 0% 100%)

.cup-handle
  position absolute
  top 0.54rem
  width 0.52rem
  height 0.74rem
  border 0.1rem solid #F2C54E
  border-radius 50%
  &.handle-left
    left 0.16rem
    border-right-color transparent
    transform rotate(-10deg)
  &.handle-right
    right 0.16rem
    border-left-color transparent
    transform rotate(10deg)

.cup-base
  position absolute
  top 1.64rem
  left 0.84rem
  width 0.52rem
  height 0.48rem
  background linear-gradient(180deg, #FBE3A0 0%, #D89A1D 100%)
  clip-path polygon(30% 0%, 70% 0%, 100% 100%, 0% 100%)

.cup-stand
  position absolute
  top 2.06rem
  left 0.58rem
  width 1.04rem
  height 0.26rem
  border-radius 0.08rem
  background linear-gradient(180deg, #7A161B 0%, #4F080B 100%)

.trophy-star
  position absolute
  top 0.72rem
  left 0.96rem
  font-size 0.36rem
  line-height 1
  color #FFFFFF

.hero-actions
  display flex
  flex-direction column
  gap 0.16rem
  margin-top 0.24rem

.action-btn
  width 100%
  min-height 0.84rem
  border-radius 999px
  font-size 0.28rem
  font-weight 600
  border 1px solid transparent
  &.primary
    background #FFFFFF
    color #C8161D
  &.ghost
    background transparent
    color #FFFFFF
    border-color rgba(255, 255, 255, 0.28)

.section-card
  margin-top 0.28rem
  background #FFFFFF
  border-radius 0.28rem
  padding 0.32rem 0.28rem
  box-shadow 0 0.1rem 0.3rem rgba(17, 17, 17, 0.04)

.section-header
  display flex
  align-items center
  gap 0.16rem
  margin-bottom 0.22rem
  h2
    font-size 0.38rem
    line-height 0.54rem
    color #2D1A1B
    font-weight 700

.section-tag
  width 0.56rem
  height 0.56rem
  border-radius 0.16rem
  background rgba(200, 22, 29, 0.08)
  color #C8161D
  display inline-flex
  align-items center
  justify-content center
  font-size 0.22rem
  font-weight 700

.section-intro
  font-size 0.26rem
  line-height 0.42rem
  color #666666
  margin-bottom 0.2rem

.form-card
  padding 0.26rem 0.22rem
  border-radius 0.22rem
  background linear-gradient(180deg, #FFF9F9 0%, #FFFFFF 100%)
  border 1px solid #F0DDDE
  /deep/.ivu-form-item
    margin-bottom 0.26rem
  /deep/.ivu-form-item-label
    color #2D1A1B
    font-size 0.26rem
    line-height 0.4rem
    margin-bottom 0.08rem
  /deep/.ivu-input
  /deep/.ivu-input-wrapper textarea.ivu-input
    border-color #E8D5D7
    border-radius 0.16rem
    font-size 0.28rem
  /deep/.ivu-input:focus
  /deep/.ivu-input:hover
    border-color #C8161D
    box-shadow none

.field-tip
  margin-top 0.12rem
  display flex
  justify-content space-between
  gap 0.16rem
  font-size 0.22rem
  line-height 0.34rem
  color #999999
  .word-count
    color #666666
    &.danger
      color #ED4014

.upload-wrapper
  display flex
  flex-direction column
  align-items flex-start
  gap 0.14rem
  .file-input
    display none
  .upload-text
    font-size 0.22rem
    line-height 0.34rem
    color #999999

.upload-file
  margin-top 0.14rem
  min-height 0.64rem
  display flex
  align-items center
  justify-content space-between
  gap 0.16rem
  padding 0.12rem 0.16rem
  border-radius 0.16rem
  background #FFF3F3
  color #5A5A5A
  font-size 0.24rem
  line-height 0.34rem
  word-break break-all

.submit-btn-wrapper
  padding-top 0.06rem

.submit-btn
  width 100%
  height 0.88rem
  background #C8161D
  border-color #C8161D
  border-radius 999px
  font-size 0.28rem
  &:hover
    background #E24147
    border-color #E24147

.about-text
  p
    font-size 0.28rem
    line-height 0.48rem
    color #4A4A4A
    & + p
      margin-top 0.14rem

.eligibility-grid
  display grid
  grid-template-columns 1fr 1fr
  gap 0.18rem

.eligibility-card
  padding 0.24rem 0.2rem
  border-radius 0.22rem
  background linear-gradient(180deg, #FFF8F8 0%, #FFFFFF 100%)
  border 1px solid #F4DFE0
  h3
    margin-top 0.16rem
    font-size 0.3rem
    line-height 0.42rem
    color #2D1A1B
    font-weight 700
  p
    margin-top 0.08rem
    font-size 0.24rem
    line-height 0.4rem
    color #666666

.icon-box
  width 0.56rem
  height 0.56rem
  border-radius 0.16rem
  background linear-gradient(135deg, #FCE6E7 0%, #F7C6C9 100%)
  position relative
  &:before
    content ''
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    background #C8161D
  &.enterprise:before
    width 0.24rem
    height 0.18rem
    border-radius 0.04rem
    box-shadow 0 -0.08rem 0 -0.04rem #C8161D, -0.08rem 0.08rem 0 -0.06rem #C8161D, 0.08rem 0.08rem 0 -0.06rem #C8161D
  &.innovation:before
    width 0.18rem
    height 0.18rem
    border-radius 50%
    box-shadow 0 -0.12rem 0 -0.06rem #C8161D, 0 0.12rem 0 -0.06rem #C8161D, -0.12rem 0 0 -0.06rem #C8161D, 0.12rem 0 0 -0.06rem #C8161D
  &.trust:before
    width 0.18rem
    height 0.24rem
    clip-path polygon(50% 0%, 100% 18%, 100% 55%, 50% 100%, 0% 55%, 0% 18%)
  &.material:before
    width 0.2rem
    height 0.24rem
    border-radius 0.04rem
    box-shadow 0 -0.08rem 0 -0.06rem #FFFFFF inset

.apply-type-list
  display flex
  flex-direction column
  gap 0.18rem

.apply-type-card
  border-radius 0.22rem
  background linear-gradient(180deg, #FFF6F6 0%, #FFFFFF 100%)
  border 1px solid #F3D9DB
  padding 0.24rem
  h3
    font-size 0.34rem
    line-height 0.46rem
    color #C8161D
    margin-bottom 0.1rem
  p
    font-size 0.26rem
    line-height 0.42rem
    color #5A5A5A
    & + p
      margin-top 0.08rem

.example-card
  margin-top 0.22rem
  padding 0.22rem
  border-radius 0.2rem
  background linear-gradient(135deg, rgba(200, 22, 29, 0.05) 0%, rgba(200, 22, 29, 0.01) 100%)
  border 1px dashed rgba(200, 22, 29, 0.28)
  .example-title
    font-size 0.3rem
    line-height 0.42rem
    color #C8161D
    font-weight 700
    margin-bottom 0.1rem
  p
    font-size 0.24rem
    line-height 0.4rem
    color #5A5A5A

.benefit-list
  display flex
  flex-direction column
  gap 0.18rem

.benefit-card
  background linear-gradient(180deg, #FFF8F8 0%, #FFFFFF 100%)
  border-radius 0.22rem
  border 1px solid #F2E0E1
  padding 0.24rem
  h3
    font-size 0.34rem
    line-height 0.46rem
    color #2D1A1B
    margin-bottom 0.12rem
  ul
    padding-left 0.28rem
  li
    font-size 0.26rem
    line-height 0.42rem
    color #5A5A5A
    & + li
      margin-top 0.08rem

.timeline-scroll
  overflow-x auto
  -webkit-overflow-scrolling touch

.timeline
  min-width 10rem
  position relative
  display flex
  gap 0.18rem
  padding-top 0.02rem

.timeline-line
  position absolute
  top 0.18rem
  left 0.34rem
  right 0.34rem
  height 2px
  background linear-gradient(90deg, rgba(200, 22, 29, 0.2) 0%, rgba(200, 22, 29, 0.8) 100%)

.timeline-item
  position relative
  z-index 1
  width 1.9rem
  flex 0 0 1.9rem

.timeline-dot
  width 0.18rem
  height 0.18rem
  border-radius 50%
  background #C8161D
  box-shadow 0 0 0 0.06rem rgba(200, 22, 29, 0.12)
  margin 0 auto

.timeline-short
  margin-top 0.12rem
  font-size 0.22rem
  line-height 0.3rem
  color #C8161D
  text-align center
  font-weight 700

.timeline-card
  margin-top 0.14rem
  padding 0.16rem
  border-radius 0.18rem
  background #FFF9F9
  border 1px solid #F2DEDF
  min-height 2.2rem
  .timeline-time
    font-size 0.22rem
    line-height 0.3rem
    color #C8161D
    font-weight 700
  .timeline-title
    margin-top 0.08rem
    font-size 0.28rem
    line-height 0.38rem
    color #2D1A1B
    font-weight 700
  p
    margin-top 0.08rem
    font-size 0.22rem
    line-height 0.34rem
    color #666666
</style>
